module.exports = __webpack_public_path__ + "static/img/cj13.e787bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj13.png
// module id = 54
// module chunks = 0